import { useState } from 'react';

const faqs = [
  { q: 'Are you a manufacturer or a trading company?', a: 'We are a professional steel trading company based in China. We work directly with verified Chinese steel mills to source products on your behalf — giving you factory-level pricing with the reliability of a trusted trading partner.' },
  { q: 'What products do you supply?', a: 'We supply a wide range of steel products including cold-rolled coils, hot-rolled coils, galvanized coils, rebar, H-beams, steel pipes (ERW, seamless, LSAW), roofing sheets, structural sections, and more.' },
  { q: 'What payment methods do you accept?', a: 'We accept T/T (bank wire transfer) and L/C (Letter of Credit). We are flexible and can discuss payment terms based on order size and relationship.' },
  { q: 'Do you provide mill test certificates?', a: 'Yes. All products come with mill test certificates (MTC). We can also arrange third-party inspection by SGS, TUV, or BV before shipment upon request.' },
  { q: 'What is the minimum order quantity?', a: 'MOQ varies by product. Generally, we work with orders from 25 metric tons and above. Contact us with your requirements and we will advise accordingly.' },
  { q: 'How long does shipping take?', a: 'Lead time is typically 15–30 days after order confirmation and deposit. Shipping time depends on destination port — usually 15–45 days by sea freight.' },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          <div className="lg:w-1/2 text-center lg:text-left">
            <span className="text-xs font-bold tracking-widest uppercase mb-2 block" style={{ color: '#0a2342' }}>FAQ</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">Common Questions</h2>
            <p className="text-gray-600 text-sm mb-6">
              Everything you need to know about working with Steelinkglobal as your China steel sourcing partner.
            </p>
            <div className="w-full h-[280px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=steel%20coils%20warehouse%20storage%20industrial%20facility%20professional%20photography&width=600&height=400&seq=faq-img-steelink-1&orientation=landscape"
                alt="Steel warehouse"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
          <div className="lg:w-1/2 w-full">
            {faqs.map((faq, i) => (
              <div key={i} className="border-b border-gray-200">
                <button
                  className="w-full flex items-center justify-between py-4 text-left cursor-pointer"
                  onClick={() => setOpen(open === i ? -1 : i)}
                >
                  <span className="text-sm font-bold text-gray-800 pr-4">{faq.q}</span>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${open === i ? '' : 'bg-gray-100'}`}
                    style={open === i ? { backgroundColor: '#0a2342' } : {}}>
                    <i className={`ri-arrow-down-s-line text-sm transition-transform ${open === i ? 'rotate-180 text-white' : 'text-gray-500'}`} />
                  </div>
                </button>
                {open === i && (
                  <div className="pb-4 text-sm text-gray-600 leading-relaxed">{faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
